import $ from "cash-dom";

export default {
  install(Vue) {
    const itemClick = function($el) {
      $el.find("a").on("click", function() {
        $(this)
          .parent()
          .siblings()
          .removeClass("-active");
        $(this)
          .parent()
          .addClass("-active");
      });

      if (location.hash) {
        $el.find('a[href="' + location.hash + '"]').trigger("click");
      }
    };

    const spyMenu = function($el, scrollFromTop, edge) {
      edge += 80;

      const $links = $el.find("a");
      $links.each(function() {
        var target = $($(this).attr("href"));
        if (target.length) {
          if (
            scrollFromTop >= $(target).offset().top - edge &&
            !$(this)
              .parent()
              .hasClass("-active")
          ) {
            $('a[href*="#"]')
              .parent()
              .removeClass("-active");
            $(this)
              .parent()
              .addClass("-active");
          }
        }
      });
    };

    Vue.directive("gd-spy-bot", {
      beforeMount() {},

      mounted(el) {
        const $el = $(el);
        const edge =
          document.querySelector(".is-fixed").clientHeight +
          document.querySelector(".is-fixed2").clientHeight;

        window.onscroll = function() {
          let scrollFromTop =
            document.documentElement.scrollTop + document.body.scrollTop;
          spyMenu($el, scrollFromTop, edge);
        };

        itemClick($el);
      },

      updated() {}
    });
  }
};
